<ng-container
  *ngIf="showCard && !!marketingContent"
  [ngSwitch]="marketingContent.layout"
>
  <ng-container *ngSwitchCase="'layout1'">
    <mat-card
      class="main fld-col mwr-5"
      tabindex="0"
      (click)="clickCard.emit()"
      (keydown.enter)="$event.preventDefault()"
      (keyup.enter)="clickCard.emit()"
    >
      <button
        *ngIf="marketingContent.isDismissable"
        mat-icon-button
        aria-label="Dismiss card"
        class="close-btn"
        (click)="handleDismissCard()"
        (keydown.enter)="$event.preventDefault()"
        (keyup.enter)="handleDismissCard()"
      >
        <mat-icon>cancel</mat-icon>
      </button>
      <img
        class="main-image"
        src="{{ marketingContent.homePageCardImage }}"
        alt="{{ marketingContent.homePageCardCaption }}"
      />

      <div class="footer fs-u2 pwa-5 fls-1-1">
        Use promo code:
        <span class="fw-u1"> {{ marketingContent.promoCode }} </span>
      </div>
    </mat-card>
  </ng-container>

  <myqq-ceramic-upgrade
    *ngSwitchCase="'ceramicUpgrade'"
    [showPromo]="!!marketingContent.promoCode"
    (upgrade)="clickCard.emit()"
  >
  </myqq-ceramic-upgrade>

  <ng-container *ngSwitchCase="'layout2'">
    <div
      class="card-layout2 main mwr-5"
      tabindex="0"
      (click)="clickCard.emit()"
      (keydown.enter)="$event.preventDefault()"
      (keyup.enter)="clickCard.emit()"
    >
      <button
        *ngIf="marketingContent.isDismissable"
        mat-icon-button
        aria-label="Dismiss card"
        class="close-white-btn"
        (click)="handleDismissCard()"
        (keydown.enter)="$event.preventDefault()"
        (keyup.enter)="handleDismissCard()"
      >
        <mat-icon>cancel</mat-icon>
      </button>
      <img
        class="main-image-layout2"
        src="{{ marketingContent.homePageCardImage }}"
        alt="{{ marketingContent.homePageCardCaption }}"
      />
    </div>
  </ng-container>
</ng-container>
